import { useBandwidth } from "../context/BandwidthContext";
import "./BandwidthToggle.css";

export default function BandwidthToggle() {
  const { lowData, toggleBandwidth } = useBandwidth();

  return (
    <button
      type="button"
      className={`bw-toggle ${lowData ? "is-on" : ""}`}
      onClick={toggleBandwidth}
      aria-pressed={lowData}
      aria-label="Toggle low-bandwidth mode"
      title={
        lowData
          ? "Low-bandwidth mode: ON — lighter visuals, less data"
          : "Low-bandwidth mode: OFF"
      }
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M2 20h.01M6 20a4 4 0 0 1 4-4M2 16a8 8 0 0 1 8-8M2 12a12 12 0 0 1 12-12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        {lowData && (
          <path
            d="M22 2 16 8"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        )}
      </svg>
      <span className="bw-toggle__label">Lite</span>
    </button>
  );
}
